export default __webpack_public_path__ + "static/media/pos-1.acc4f6fe.png";